const useLive = false;

export const liveApiUrl = "https://ai-api.realtimefeedback.com";

export const apiUrl =
  (!process.env.NODE_ENV || process.env.NODE_ENV === "development") && !useLive
    ? (import.meta.env.VITE_API_URL || "http://localhost:8000")
    : liveApiUrl;
